// import UserStore from './userStore';
// import RequestStore from './requestStore';
import OfficeStore from './officeStore';
import CoachmarkStore from './coachmarkStore';
import SalesforceStore from './salesforceStore';
import ContextStore from './contextStore';
import DataStore from './dataStore';
import UserStore from '@v2/stores/userStore';
import RequestStore from '@v2/stores/requestStore';
import HubspotStore from "@v2/stores/hubspotStore";
import { FlowstepStorage } from '@v2/services/flowsteps/flowstep-storage';

const requestStore = new RequestStore();
const userStore = new UserStore();
const salesforceStore = new SalesforceStore();
const dataStore = new DataStore();
const contextStore = new ContextStore();
const officeStore = new OfficeStore();
const coachmarkStore = new CoachmarkStore();
const hubspotStore = new HubspotStore(userStore);

salesforceStore.linkStores({ requestStore, userStore });
dataStore.linkStores({ requestStore, userStore, contextStore });
contextStore.linkStores({ requestStore, userStore, dataStore, salesforceStore });
coachmarkStore.linkStores({ userStore });
officeStore.linkStores({ requestStore, userStore, salesforceStore, hubspotStore, contextStore, dataStore, coachmarkStore });
userStore.linkStores({ requestStore });

const flowstepStorage = new FlowstepStorage(Office.context);
flowstepStorage.addEventListener(
  'save-flowstep',
  async () => {
    await dataStore.fetchFlows();
    await dataStore.fetchFlowsteps();
    await dataStore.updateSchedulerFlows();
  }
);
flowstepStorage.addEventListener(
  'delete-flowstep',
  async () => {
    await dataStore.fetchFlows();
    await dataStore.fetchFlowsteps();
    await dataStore.updateSchedulerFlows();
  }
);

export {
  userStore,
  officeStore,
  requestStore,
  coachmarkStore,
  salesforceStore,
  dataStore,
  contextStore,
  hubspotStore,
  flowstepStorage
}
